import Vue from 'vue'

const changeFirstLetterToSmall = string => string.replace(/^[A-Z]/g, letter => letter.toLowerCase())

const listOfComponents = [
  'BaseNavigationTabs',
  'BaseSnackbar',
  'BaseTooltip',
]

listOfComponents.forEach(item => {
  const path = `./${item}`
  Vue.component(changeFirstLetterToSmall(item).camelToSnakeCase('-'), () => import('' + path))
})

// Vue.component('base-navigation-tabs', () => import('./BaseNavigationTabs'))
// components
